"use client";
import { checkUserStatus } from "@/app/database/product/firebase";
import { hasGithubUsername, logout } from "@/app/database/standard/firebase";
import { handleButtonTracking } from "@/app/utils/button-tracking";
import { handleCheckoutSession } from "@/app/utils/checkout-session";
import { handleHeaderClick } from "@/app/utils/scroll";
import { ScrollProgress } from "@/components/magicui/scroll-progress";
import { DISCOUNT_ID, PRICING_ID_T1, PRICING_NAME_T1 } from "@/lib/constants";
import Image from "next/image";
import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import MobileMenu from "./MobileMenu";

export default function Header() {
  const pathname = usePathname();
  const router = useRouter();
  const [uid, setUID] = useState("");
  const [isScrolled, setIsScrolled] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 45);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const checkStatus = async () => {
      const status = await checkUserStatus();
      setIsLoggedIn(status);
    };

    checkStatus();
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
      window.location.href = "/";
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div
      className={`bg-transparent ${pathname === "/extension/cancel" || pathname === "/extension/success" ? "hidden" : ""}`}
    >
      <header
        className={`w-full z-30 transition-all duration-300 ${
          isScrolled
            ? "top-0 fixed shadow-md bg-[#222222] bg-opacity-70 backdrop-blur-md"
            : "absolute bg-[#222222] bg-opacity-0"
        }`}
      >
        <ScrollProgress
          className={`absolute h-[4px] bg-gradient-to-r from-primary via-red-500 to-orange-500 ${
            isScrolled ? "top-14" : "top-14"
          }`}
        />
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="flex items-center justify-between relative h-14">
            <div className="shrink-0 mr-4">
              <Link
                href="/"
                className="flex items-center z-10"
                aria-label="Cruip"
              >
                <Image
                  className="w-8"
                  width={500}
                  height={500}
                  src="/images/product/logo.webp"
                  alt="Website logo"
                />
                <p className="pl-2 text-xl text-primary font-semibold">
                  <span className="text-white">Notify</span>API
                </p>
              </Link>
            </div>

            <nav className="hidden lg:flex inset-x-0 flex justify-center pointer-events-none">
              <ul className="flex items-center pointer-events-auto gap-x-3"></ul>
            </nav>

            <div className="indicator hidden lg:flex items-center space-x-4 right-4">
              <Link
                href="/"
                className="group relative inline-flex items-center justify-center btn-sm bg-primary text-white hover:bg-secondary rounded-xl gap-x-1"
              >
                <p>Join Waitlist</p>
                <div className="relative ml-1 h-5 w-5 overflow-hidden">
                  <div className="absolute transition-all duration-200 group-hover:-translate-y-5 group-hover:translate-x-4">
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                    >
                      <path
                        d="M3.64645 11.3536C3.45118 11.1583 3.45118 10.8417 3.64645 10.6465L10.2929 4L6 4C5.72386 4 5.5 3.77614 5.5 3.5C5.5 3.22386 5.72386 3 6 3L11.5 3C11.6326 3 11.7598 3.05268 11.8536 3.14645C11.9473 3.24022 12 3.36739 12 3.5L12 9.00001C12 9.27615 11.7761 9.50001 11.5 9.50001C11.2239 9.50001 11 9.27615 11 9.00001V4.70711L4.35355 11.3536C4.15829 11.5488 3.84171 11.5488 3.64645 11.3536Z"
                        fill="currentColor"
                        fillRule="evenodd"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 -translate-x-4"
                    >
                      <path
                        d="M3.64645 11.3536C3.45118 11.1583 3.45118 10.8417 3.64645 10.6465L10.2929 4L6 4C5.72386 4 5.5 3.77614 5.5 3.5C5.5 3.22386 5.72386 3 6 3L11.5 3C11.6326 3 11.7598 3.05268 11.8536 3.14645C11.9473 3.24022 12 3.36739 12 3.5L12 9.00001C12 9.27615 11.7761 9.50001 11.5 9.50001C11.2239 9.50001 11 9.27615 11 9.00001V4.70711L4.35355 11.3536C4.15829 11.5488 3.84171 11.5488 3.64645 11.3536Z"
                        fill="currentColor"
                        fillRule="evenodd"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </div>
                </div>
              </Link>
            </div>
            <MobileMenu />
          </div>
        </div>
      </header>
    </div>
  );
}
